import { Button } from "@xola/ui-kit";
import { useMount } from "ahooks";
import React from "react";
import { MobileAppsMessages, XolaMobileApp } from "types";
import { ContentLayout } from "../Layout/ContentLayout";
import { useXolaMobileApps } from "../MobileApps/XolaMobileAppsContext";

export const TabletAppSettings = () => {
    const { sendMessage, xolaMobileApp } = useXolaMobileApps();
    useMount(() => {
        if (xolaMobileApp === XolaMobileApp.XolaTablet) {
            sendMessage({ type: MobileAppsMessages.OPEN_TABLET_SETTINGS });
        }
    });
    const handleOpenSettings = () => {
        if (xolaMobileApp === XolaMobileApp.XolaTablet) {
            sendMessage({ type: MobileAppsMessages.OPEN_TABLET_SETTINGS });
        }
    };

    return (
        <ContentLayout isWide className="space-y-4 divide-y divide-gray-lighter">
            <div>
                <h2 className="mt-4 mb-4">Xola Tablet App</h2>
                {xolaMobileApp === XolaMobileApp.XolaTablet ? (
                    <Button onClick={handleOpenSettings}>Show Tablet App Settings</Button>
                ) : (
                    <h3>This section is only available when running Xola inside the Tablet App.</h3>
                )}
            </div>
        </ContentLayout>
    );
};
